<div class="d-flex flex-column">
  @for (currentStats of stats | keyvalue; track currentStats) {
  <div class="d-flex flex-row">
    <div class="item me-3">
      <div class="year">{{ currentStats.key || 'N/A' }}</div>
    </div>
    <div class="item">
      <div class="title">{{ currentStats.value.total_relo.name }}:</div>
      <div class="number">{{ currentStats.value.total_relo.value }}</div>
    </div>
    @for (top of currentStats.value.top3; track top) {
    <div class="item">
      <div class="title">{{ top.name }}:</div>
      <div class="number">{{ top.total }}</div>
    </div>
    }
  </div>
  }
</div>
